const sanitize = (value) => {
  const text = String(value ?? "").replace(/"/g, '""');
  return `"${text}"`;
};

const getFullName = (member = {}) =>
  [member?.userFirstName, member?.userMiddleName, member?.userLastName]
    .filter(Boolean)
    .join(" ");

const getMobileNumber = (member = {}) =>
  member?.userMobile ||
  member?.mobileNumber ||
  member?.user?.userMobile ||
  member?.user?.mobileNumber ||
  member?.userId?.userMobile ||
  member?.userId?.mobileNumber ||
  member?.phoneNumber ||
  "";

export const exportNetworkMembersCsv = (rows = [], fileName = "network_members") => {
  const headers = [
    "Name",
    "Mobile No",
    "Position",
    "Committee",
    // "Committee Type",
    // "Member Type",
    "State",
    "Region",
    "District",
    "City",
    // "Joining Date",
    // "Updated At",
  ];

  const lines = rows.map((member) =>
    [
      getFullName(member),
      getMobileNumber(member),
      member?.position || "",
      member?.committee || "",
      // member?.committeeType || "",
      // member?.committeeSubtype || member?.committeeSubType || "",
      member?.state || "",
      member?.region || "",
      member?.district || "",
      member?.city || "",
      // member?.joiningDate || "",
      // member?.updatedAt || "",
    ]
      .map(sanitize)
      .join(","),
  );

  const csv = [headers.map(sanitize).join(","), ...lines].join("\n");
  const blob = new Blob(["\uFEFF", csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${fileName}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
